/**
 * WOODWORKING FURNITURE PLANS™ — purchase configuration.
 *
 * CHECKOUT_URL is the single destination used by every purchase button
 * (offer CTA, final CTA and mobile sticky bar). Paste the Woodworking
 * checkout URL here when it is available (must start with https://).
 *
 * While it is empty, every purchase button scrolls to the offer (#offer)
 * so no visitor is sent to a wrong or missing checkout.
 */
export const CHECKOUT_URL = ''

export const PRICE = {
  value: 29,
  currency: 'USD',
  label: 'US$29',
  note: 'One-time payment. Digital PDF collection.',
} as const
